import { DataBlockProps } from './types'
import styles from './DataBlock.module.scss'
import { PropsWithChildrenAndClassName } from '@boltenergy-be/design-system'
import classNames from 'classnames'

const DataBlock = ({ label, children, className }: PropsWithChildrenAndClassName<DataBlockProps>) => (
  <div className={classNames(styles.block, className)}>
    {label && <strong>{label}</strong>}
    {children}
  </div>
)

export default DataBlock
